/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE --------------------------------
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { getInformacionEmpresa } from "../../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";

// ------------------- CONSULTAS A LA API --------------------------------
import { obtenerDetalleSalidaPacasPorSalida } from "../../../../../../API/Suministros/SalidasMateriales/SalidasMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import { ReporteSalidaMPLang } from "./ReporteSalidaMPLang";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ReporteSalidaMP = ({
  showReporte,
  setShowReporte,
  salida,
  Language = "es",
}) => {
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  const toast = useRef(null);
  const lang = ReporteSalidaMPLang[Language] || ReporteSalidaMPLang.es;

  const obtenerImagenPDF = (img) => {
    if (!img || typeof img !== "string") {
      return null;
    }

    const limpia = img.trim();

    if (
      !limpia ||
      limpia === "null" ||
      limpia === "undefined" ||
      limpia.startsWith("http")
    ) {
      return null;
    }

    if (limpia.startsWith("data:image/")) {
      return limpia;
    }

    const esBase64 = /^[A-Za-z0-9+/]+={0,2}$/.test(limpia);

    if (!esBase64) {
      return null;
    }

    return `data:image/png;base64,${limpia}`;
  };

  const formatoNumero = (valor) => {
    return Number(valor || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatoFecha = (fecha) => {
    if (!fecha) return "";

    const f = new Date(fecha);

    return f.toLocaleString("es-HN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const generarPDF = async (infoEmpresa, pacas) => {
    const logoB64 = obtenerImagenPDF(infoEmpresa?.LogoPrimarioB64);
    const cantidadPacas = Number(salida?.QtySalidaPacas || 0) || (pacas || []).length;
    // Kg es la unidad principal; las libras se muestran como referencia
    const kgPaca = (paca) => Number(paca?.PesoNetoKg ?? paca?.PesoNeto ?? 0);
    const lbsPaca = (paca) => Number(paca?.PesoNetoLbs ?? paca?.Net ?? 0);
    const pesoNeto = Number(salida?.QtySalida ?? 0) ||
      (pacas || []).reduce((total, paca) => total + kgPaca(paca), 0);
    const pesoNetoLbs = Number(salida?.QtySalidaLbs ?? 0) ||
      (pacas || []).reduce((total, paca) => total + lbsPaca(paca), 0);

    const fechaImpresion = new Date().toLocaleString("es-HN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [35, 45, 35, 55],

      // FOOTER
      footer: (currentPage, pageCount) => {
        return {
          margin: [35, 10, 35, 0],

          columns: [
            {
              width: "*",
              text: `${lang.fechaImpresion} ${fechaImpresion}`,
              fontSize: 7,
              alignment: "left",
            },

            {
              width: "*",
              text: `${lang.pagina} ${currentPage} / ${pageCount}`,
              fontSize: 7,
              alignment: "right",
            },
          ],
        };
      },

      // CONTENIDO
      content: [
        // ENCABEZADO
        {
          columns: [
            // IZQUIERDA - LOGO
            {
              width: 200,

              stack: [
                logoB64
                  ? {
                      image: logoB64,
                      width: 200,
                      margin: [0, -30, 0, 0],
                    }
                  : {
                      text: infoEmpresa?.NombreLegal || "",
                      bold: true,
                      fontSize: 11,
                    },
              ],
            },

            // CENTRO - TITULO + REQUISA
            {
              width: "*",

              stack: [
                {
                  text: lang.titulo,
                  bold: true,
                  fontSize: 16,
                  alignment: "center",
                  margin: [0, 0, 0, 8],
                },

                {
                  text: lang.noRequisa,
                  bold: true,
                  fontSize: 10,
                  alignment: "center",
                  margin: [0, 0, 0, 2],
                },

                {
                  text: salida?.Requisa || "",
                  bold: true,
                  fontSize: 11,
                  alignment: "center",
                },
              ],
            },

            // DERECHA - INFORMACION
            {
              width: 220,

              stack: [
                {
                  text: [
                    {
                      text: `${lang.area} `,
                      bold: true,
                    },
                    {
                      text: salida?.Area || "",
                    },
                  ],
                  fontSize: 10,
                  margin: [0, 0, 0, 6],
                },

                {
                  text: [
                    {
                      text: `${lang.personaSolicita} `,
                      bold: true,
                    },
                    {
                      text: salida?.UserNameAutorizoSolicita || "",
                    },
                  ],
                  fontSize: 10,
                },
              ],
            },
          ],

          columnGap: 15,

          margin: [0, 0, 0, 20],
        },

        // TABLA UNICA DE PACAS DESPACHADAS
        {
          table: {
            headerRows: 1,

            widths: [
              60, // Estado
              95, // Fecha
              "*", // Producto
              85, // Gin Bale
              80, // Correlativo
              60, // Grado
              75, // Peso Neto Kg
              75, // Peso Neto Lbs
            ],

            body: [
              // ENCABEZADOS
              [
                {
                  text: lang.estado,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },

                {
                  text: lang.fecha,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },

                {
                  text: lang.producto,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },

                {
                  text: lang.ginBale,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },

                {
                  text: lang.correlativo,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },

                {
                  text: lang.grado,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },

                {
                  text: lang.pesoNeto,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },

                {
                  text: lang.pesoNetoLbs,
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
              ],

              // DETALLE
              ...pacas.map((paca) => [
                {
                  text: paca?.StatusName || salida?.StatusName || "",
                  style: "tableBody",
                  border: [false, false, false, false],
                },

                {
                  text: formatoFecha(paca?.FechaSalida || salida?.FechaSalida),
                  style: "tableBodyLeft",
                  border: [false, false, false, false],
                },

                {
                  text: paca?.NombreProducto || salida?.NombreProducto || "",
                  style: "tableBody",
                  border: [false, false, false, false],
                },

                {
                  text: `${paca?.GinBale || ""}`,
                  style: "tableBody",
                  border: [false, false, false, false],
                },

                // CORRELATIVO
                {
                  text: (() => {
                    if (!paca?.IdPaca) {
                      return "";
                    }

                    if (!paca?.FechaFactura) {
                      return "";
                    }

                    const anio = new Date(paca.FechaFactura)
                      .getFullYear()
                      .toString()
                      .slice(-2);

                    return `${anio}-${String(paca.IdPaca).padStart(4, "0")}`;
                  })(),

                  style: "tableBody",
                  border: [false, false, false, false],
                },

                // GRADO
                {
                  text: `${paca?.Grd || ""}`,
                  style: "tableBody",
                  border: [false, false, false, false],
                },

                {
                  text: `${formatoNumero(kgPaca(paca))}`,
                  style: "tableBodyRight",
                  border: [false, false, false, false],
                },

                {
                  text: `${formatoNumero(lbsPaca(paca))}`,
                  style: "tableBodyRight",
                  border: [false, false, false, false],
                },
              ]),
            ],
          },
          //layout: "noBorders",
          margin: [0, 0, 0, 15],
        },

        // COMENTARIO + TOTALES
        {
          columns: [
            // COMENTARIO
            {
              width: "*",

              stack: [
                {
                  text: [
                    {
                      text: `${lang.comentario} `,
                      bold: true,
                    },
                    {
                      text:
                        salida?.Comentario || salida?.ComentarioRequisa || "",
                    },
                  ],

                  fontSize: 9.5,
                },
              ],
            },

            // TOTALES
            {
              width: 190,

              table: {
                widths: [80, 85],

                body: [
                  [
                    {
                      text: lang.totalPacas,
                      style: "totalLabel",
                    },

                    {
                      text: `${cantidadPacas}`,
                      style: "totalValor",
                    },
                  ],

                  [
                    {
                      text: lang.totalPesoNeto,
                      style: "totalLabel",
                    },

                    {
                      text: `${formatoNumero(pesoNeto)} Kg`,
                      style: "totalValor",
                    },
                  ],

                  [
                    {
                      text: lang.totalPesoNetoLbs,
                      style: "totalLabel",
                    },

                    {
                      text: `${formatoNumero(pesoNetoLbs)} Lbs`,
                      style: "totalValor",
                    },
                  ],
                ],
              },

              layout: {
                hLineWidth: () => 0.7,
                vLineWidth: () => 0.7,

                hLineColor: () => "#808080",
                vLineColor: () => "#808080",

                paddingLeft: () => 3,
                paddingRight: () => 3,

                paddingTop: () => 2,
                paddingBottom: () => 2,
              },
            },
          ],
          margin: [0, 5, -6, 50],
        },

        // FIRMAS
        {
          columns: [
            // DESPACHO
            {
              width: "*",

              stack: [
                {
                  text: "__________________________________",
                  alignment: "center",
                },

                {
                  text: salida?.UserNameDespacho || "",
                  alignment: "center",
                  fontSize: 9,
                  margin: [0, 4, 0, 0],
                },

                {
                  text: lang.despacho,
                  bold: true,
                  alignment: "center",
                  fontSize: 9,
                },
              ],
            },

            // RECIBIO
            {
              width: "*",

              stack: [
                {
                  text: "__________________________________",
                  alignment: "center",
                },

                {
                  text: salida?.NombreRecibe || "",
                  alignment: "center",
                  fontSize: 9,
                  margin: [0, 4, 0, 0],
                },

                {
                  text: lang.recibio,
                  bold: true,
                  alignment: "center",
                  fontSize: 9,
                },
              ],
            },

            // AUTORIZA
            {
              width: "*",

              stack: [
                {
                  text: "__________________________________",
                  alignment: "center",
                },

                {
                  text: salida?.UserNameAutorizoSolicita || "",
                  alignment: "center",
                  fontSize: 9,
                  margin: [0, 4, 0, 0],
                },

                {
                  text: lang.autorizo,
                  bold: true,
                  alignment: "center",
                  fontSize: 9,
                },
              ],
            },
          ],
        },
      ],

      // ESTILOS
      styles: {
        labelGeneral: {
          bold: true,
          fontSize: 10,
          alignment: "left",
        },

        valorGeneral: {
          fontSize: 10,
          alignment: "left",
        },

        tableHeader: {
          bold: true,
          fontSize: 10,
          alignment: "center",
          fillColor: "#D9EAF7",
          color: "#000000",
          margin: [0, 5, 0, 5],
        },

        tableBody: {
          fontSize: 8.5,
          alignment: "center",
          margin: [0, 3, 0, 3],
        },

        tableBodyLeft: {
          fontSize: 8,
          alignment: "left",
          margin: [0, 3, 0, 3],
        },

        tableBodyRight: {
          fontSize: 8.5,
          alignment: "right",
          margin: [0, 3, 0, 3],
        },

        totalLabel: {
          bold: true,
          fontSize: 9,
          alignment: "right",
        },

        totalValor: {
          bold: true,
          fontSize: 9,
          alignment: "right",
        },
      },

      defaultStyle: {
        fontSize: 9,
      },
    };

    const pdf = pdfMake.createPdf(docDefinition);

    pdf.getDataUrl((url) => {
      setPdfUrl(url);
    });
  };

  const obtenerInformacion = async () => {
    try {
      setLoading(true);

      if (!salida?.IdSalidaDetalle) {
        return;
      }

      const [informacionEmpresa, pacas] = await Promise.all([
        getInformacionEmpresa(),

        obtenerDetalleSalidaPacasPorSalida(salida.IdSalidaDetalle),
      ]);

      await generarPDF(informacionEmpresa?.[0] || {}, pacas || []);
    } catch (error) {
      console.error("Error generando reporte Salida MP:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showReporte) {
      obtenerInformacion();
    }
  }, [showReporte]);

  return (
    <Dialog
      visible={showReporte}
      onHide={() => setShowReporte(false)}
      style={{
        width: "63vw",
        height: "85vh",
      }}
    >
      <Loader loading={loading} />

      <Toast ref={toast} />

      {!loading && pdfUrl && (
        <iframe
          src={pdfUrl}
          style={{
            width: "60vw",
            height: "75vh",
            border: "1px solid #ccc",
          }}
          title="Salida Materia Prima"
        />
      )}
    </Dialog>
  );
};

export default ReporteSalidaMP;
